export interface ILocale {
  code: string;
  name: string;
}

const locales: ILocale[] = [{ code: 'da', name: 'Dansk' }];

export default locales;
